"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.olapicResponseReportSchema = void 0;
var _zod = require("zod");
const olapicResponseReportSchema = exports.olapicResponseReportSchema = _zod.z.object({
  metadata: _zod.z.object({
    code: _zod.z.number(),
    message: _zod.z.string(),
    version: _zod.z.string()
  }),
  data: _zod.z.object({
    message: _zod.z.string().optional()
  }).optional()
});
